import { Component, OnInit, Inject, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { Observable, of, Subject } from 'rxjs';
import { map, mergeMap, skip, switchMap, take, takeUntil } from 'rxjs/operators';
import { LinkStatusCode } from '../../enums/link-status-code.enum';
import { Link } from '../../interfaces/link.interface';
import { MarketPlaceItem } from '../../interfaces/market-place-item.interface';
import { SelectedCompanyService } from '../../selected-company/selected-company.service';
import { LinkService } from '../../services/link.service';
import { MarketPlaceItemService } from '../../services/market-place-item.service';
import { LinkEditComponent } from '../link-edit/link-edit.component';
import { LinkHeaderComponent } from '../link-header/link-header.component';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'al-link-edit-page',
    templateUrl: './link-edit-page.component.html',
    styleUrls: ['./link-edit-page.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        LinkHeaderComponent,
        LinkEditComponent,
        AsyncPipe,
    ],
})
export class LinkEditPageComponent implements OnInit, OnDestroy {
	/** Observable containing all page data */
	public link$: Observable<Link>;
	public linkInfo$: Observable<MarketPlaceItem[]>;
	public routeQueryParams$: Observable<{ instanceId: string | null; jobLogId: number | null }>;

	private destroy$ = new Subject<void>();

	constructor(
		private route: ActivatedRoute,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		private linkService: LinkService,
		private marketPlaceItemService: MarketPlaceItemService,
		private cdr: ChangeDetectorRef,
		private selectedUserCompanyService: SelectedCompanyService
	) {}

	ngOnInit(): void {
		this.routeQueryParams$ = this.route.queryParamMap.pipe(
			map(params => ({
				instanceId: params.get('instanceId'),
				jobLogId: Number(params.get('jobLogId')) || null,
			}))
		);

		this.route.paramMap.pipe(take(1)).subscribe((params: ParamMap) => {
			let id = +params.get('id');
			if (id > 0) {
				this.link$ = this.linkService.get(id);
				this.linkInfo$ = this.marketPlaceItemService.getFromLink(id);
				// this.linkInfo$.subscribe(e => {
				// });
			} else {
				this.link$ = of({
					companyId: -1,
					name: '',
					description: '',
					expiryDate: null,
					saveLogs: false,
					mailAddress: '',
					mailLogs: true,
					toAppLoginId: -1,
					fromAppLoginId: -1,
					fromLinkTemplateId: -1,
					toLinkTemplateId: -1,
					toApplicationLoginId: -1,
					fromApplicationLoginId: -1,
					statusColor: LinkStatusCode.Undefined,
					statusLabel: '',
					hourlySchedulerAllowanceHours: null
				});
				this.route.queryParamMap
					.pipe(
						map(r => r.get('linkInfoId')),
						takeUntil(this.destroy$)
					)
					.subscribe(linkInfoId => this.initLinkInfo(Number(linkInfoId)));
			}
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	initLinkInfo(id: number): void {
		this.linkInfo$ = this.marketPlaceItemService.getOne(id);
	}
}
